import api from '@/services/api';

export const state = () => ({
  fieldList: [],
  selectedFieldId: null,
});

export const getters = {
  fieldList: ({ fieldList }) => fieldList,
  selectedFieldName: ({ fieldList, selectedFieldId }) => fieldList.find((field) => +field.id === +selectedFieldId)?.name ?? '',
};

export const mutations = {
  SET_FIELD_LIST(state, fieldList) {
    state.fieldList = fieldList;
  },
  SET_SELECTED_FIELD_ID(state, selectedFieldId) {
    state.selectedFieldId = selectedFieldId;
  },
};

export const actions = {
  async getFieldList({ commit }) {
    try {
      const res = await api.getFields();
      const fields = res.data.data;
      commit('SET_FIELD_LIST', fields);
    } catch (error) {
      console.log(error);
    }
  },
};
